/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Drastic_Tech_Start_Process_ButtonInputs */



/**
* | output |
* | --- |
* | "Start Process" |
*
* @param {Drastic_Tech_Start_Process_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_start_process_button = /** @type {((inputs?: Drastic_Tech_Start_Process_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_Start_Process_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Demarrer le processus")
	if (locale === "de") return /** @type {LocalizedString} */ ("Startvorgang")
	if (locale === "it") return /** @type {LocalizedString} */ ("Avviare il processo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Запуск процесса")
	if (locale === "es") return /** @type {LocalizedString} */ ("Iniciar proceso")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("启动流程")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロセスの開始")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रक्रिया शुरू करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Iniciar processo")
	return /** @type {LocalizedString} */ ("Start Process")
});